import HomeLayout from 'layouts/HomeLayout';
//import EngagementIndex from 'pages/EngagementIndex';
import { Navigate, Route, Routes } from 'react-router';

//import EngagementShow from 'components/EngagementShow';
import NotesPage from './pages/NotesPage';
import ClubInfosPage from './pages/ClubInfosPage';
import MembershipJoin from 'pages/payment/membership/MembershipJoin';
//import Identification from 'pages/payment/identification/Identification';
import PaymentMethodManagement from 'pages/payment/PaymentMethodManagement';
import SignupCheck from 'pages/subscription/SignupCheck';
import SelectPlan from 'pages/subscription/SelectPlan';
import MyPlan from 'pages/subscription/MyPlan';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeLayout />}>
        {/* <Route index element={<EngagementIndex />} />
        <Route path="engagements/:id/edit" element={<EngagementShow />} /> */}
        <Route path="notes/:pboard" element={<NotesPage />} />
        <Route path="notes/:pboard/:id" element={<NotesPage/>} />
        <Route path="club_infos" element={<ClubInfosPage/>} />
        <Route path="club_infos/:id" element={<ClubInfosPage/>} />
        <Route path="payment/membership" element={<MembershipJoin/>} />
        <Route path="payment/membership/:plan_key" element={<MembershipJoin/>} />
        {/* <Route path="payment/identification" element={<Identification/>} /> */}
        <Route path="payment/payment_methods" element={<PaymentMethodManagement/>} />
        <Route path="signup_check" element={<SignupCheck/>} />
        <Route path="select_plan" element={<SelectPlan/>} />
        <Route path="my_plan" element={<MyPlan/>} />
      </Route>
      {/* <Route path="*" element={<Navigate to="/" replace />}></Route> */}
    </Routes>
  );
};

export default AppRouter;
